import { useSelector } from "react-redux";
import { Dialog } from 'primereact/dialog';
import PresortDemo from "../components/table/DataTable";
import { Suspense, useEffect, useRef, useState, useTransition } from "react";
import { useGetUsersQuery } from "../store/api/userAPI"
import { Sidebar } from "primereact/sidebar";
import { employeeColumn, userColumn } from "../metadata/user";
import "./page.css"
import { } from "../store/api/orderAPI";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { useCreateOrUpdateEmployeeMutation, useDeleteEmployeeMutation, useGetEmployeeQuery } from "../store/api/employeeApi";
import { confirmPopup } from 'primereact/confirmpopup';
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { t } from "i18next";



function Employee() {
	const { data, error, isLoading } = useGetEmployeeQuery();
	const navigate = useNavigate();
	const translatedEmployeeColumns = useTranslatedColumns(employeeColumn);
	const toast = useRef(null);
	const [createOrUpdateEmployee] = useCreateOrUpdateEmployeeMutation();
	const [deleteEmployee] = useDeleteEmployeeMutation()
	const delEmployee = (event, [row]) => {
		confirmPopup({
			target: event.currentTarget,
			message: 'Вы точно хотите удалить?',
			icon: 'pi pi-exclamation-triangle',
			defaultFocus: 'reject',
			accept: (e) => {
				deleteEmployee(row.tarif_guid);

			}
		});
	};
	const actions = useActionsHook([
		{
			onClick: (e, params) => {
				navigate("/warehouse/" + params.guid)
			},
			icon: "pi pi-plus"
		},
		{
			onClick: (e, ...params) => {
				delEmployee(e, params)

			},
			icon: "pi pi-trash"
		}
	])


	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		setFormData(data)
		setVisibleLeft(state => {
			return {
				table: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}


	return (
		<>
			<Toast ref={toast} />
			<p
				style={{
					paddingLeft: 12,
					fontSize: 18,
					fontWeight: 600,
				}}
			>
				Employee
			</p>
			<PresortDemo
				isLoading={isLoading}
				data={data?.data ?? []}
				column={translatedEmployeeColumns.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
				toggleSidebar={(bool, data) => {
					setFormData(data)
					setVisibleLeft(state => {
						return {
							visible: true,
							data: data
						}
					})
				}}
				deleteHandler={(row, field) => {
					console.log(row, field);
				}}
				actions={actions}
			/>
			<SpeedDial
				model={[]}
				radius={120}
				type="quarter-circle"
				onClick={() => {
					setFormData({})
					setVisibleLeft(state => {
						return {
							visible: true,
							data: {}
						}
					})
				}}
				direction="up-left"
				style={{ right: 15, bottom: 15 }} />



			<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
				<div className="user-sidebar-edit">
					{
						translatedEmployeeColumns.filter((i) => i.editor).map(el => {
							return (
								<div>
									<Editor {...el} onBlur={onBlur} data={formData} />
								</div>
							)
						})
					}
					<div></div>
					<MyButton label={t('save')} onClick={async () => {
						await createOrUpdateEmployee(formData);
						toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
						toggleSidebar(false)
					}} />
				</div>

			</Sidebar>
		</>
	);
}

export default Employee;